import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { MouseEvent } from '@agm/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { FloorMapService } from '../floor-maps-manager/floor-map.service';
import { GeocodeService } from 'src/app/services/geocode.service';
import { ToastrService } from 'ngx-toastr';
import { GoogleMap } from '@angular/google-maps';
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
}
@Component({
  selector: 'app-floor-map-add-model',
  templateUrl: './floor-map-add-model.component.html',
  styleUrls: ['./floor-map-add-model.component.scss'],
  providers: [GeocodeService],
})
export class FloorMapAddModelComponent implements OnInit {
  @ViewChild(GoogleMap) map!: GoogleMap;
  regionControl = new FormControl('');
  zoom: number = 2;
  markers: google.maps.Marker[] = [];
  markers1: marker[] = [
    {
      lat: 51.673858,
      lng: 7.815982,
      label: 'A',
      draggable: true
    },
    {
      lat: 51.373858,
      lng: 7.215982,
      label: 'B',
      draggable: false
    },
    {
      lat: 51.723858,
      lng: 7.895982,
      label: 'C',
      draggable: true
    }
  ]
  disabled = true;
  // initial center position for the map
  lat: number = 51.673858;
  lng: number = 7.815982;
  length: number;
  displayName: any
  selectedMap = 'PDF';
  selectedRegion: any;
  selectedCampuse: any;
  selectedBuilding: any;
  floor: any;
  southWestLat: any;
  southWestLng: any;
  northEastLat: any;
  northEastLng: any;
  scaleZoom: any = "";
  area: any = "";
  address: any;
  latitude: any;
  longitude: any;
  display: any;
  northEastMarkerOption = {
    draggable: true
  }
  southWestMarkerOption = {
    draggable: true
  }
    options: google.maps.MapOptions = {
    mapTypeId: 'roadmap', // 'terrain', 'roadmap', or 'hybrid' based on your needs
    zoomControl: true,
    scrollwheel: true,
    fullscreenControl: true,
    disableDoubleClickZoom: true,
    streetViewControl: true, // Enable street view
    mapTypeControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    styles: [
      {
        featureType: 'all',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }]
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }]
      }
    ]
  };
  
  center = {
    lat: 0,
    lng: 0
  };
  markerOptions = {
    draggable: false
  };
  markerPositions = [];
  markerPosition: any
  maptype: any
  selectedMapId: any;
  // options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;
  myControl = new FormControl('');
  campusControl = new FormControl('');
  buildingControl = new FormControl('');

  regions: any;
  regionsList: any = []
  editData: any
  region: any;
  mapType: any;
  map_type: any;
  formData: any
  filename: any;
  regionLocation: any;
  addressLocation: any;
  imageError: boolean;
  error: string;
  imageUrl: any;
  // string | ArrayBuffer
  imagedata: any;
  imageName: any;
  isSpinner: boolean;
  id: any;
  regionsArray: any[] = [];
  rowData: any;
  campusOptions: any[] = [];
  campusArray: any[] = [];
  buildingOptions: any[] = [];
  buildArray: any[] = [];
  tabIndex = 0;
  imageBounds: { north: number; east: number; south: number; west: number; };
  northEast: { lat: any; lng: any; };
  southWest: { lat: any; lng: any; };
  action: any;
  importData: any[] = [];
  index: number = 0;
  mapsArray: any[] = [];
  updateButton: boolean = false;
  campusFilterOptions: Observable<string[]>;
  buildingFilterOptions: Observable<string[]>;
  blobtimeout: any;
  searchString: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  constructor(public dialogRef: MatDialogRef<FloorMapAddModelComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private toast: ToastrService,private ngZone: NgZone,
    private floormapService: FloorMapService,
    private geocodeService: GeocodeService, @Inject('fileServerUrl') private fileServerUrl: string,
  ) {

  }
  ngOnInit(): void {
    this.action = this.data?.action;
    if (this.action == 'Edit') {
      this.editData = this.data?.data?.data?._source;
      this.id = this.data?.data?.data?._id;
      this.displayName = this.editData?.mapname;
      this.map_type = this.editData?.map_type ? this.editData?.map_type : 'PDF';
      this.region = this.editData?.region
      this.selectedCampuse = this.editData?.campus
      this.selectedBuilding = this.editData?.building
      this.floor = this.editData?.floor
      this.southWestLat = this.editData?.south_west ? this.editData?.south_west[0] : ''
      this.southWestLng = this.editData?.south_west ? this.editData?.south_west[1] : ''
      this.northEastLat = this.editData?.north_east ? this.editData?.north_east[0] : ''
      this.northEastLng = this.editData?.north_east ? this.editData?.north_east[1] : ''
      this.scaleZoom = this.editData?.scale == '-' ? '' : this.editData?.scale;
      this.zoom = this.map_type == 'Composite' && this.editData?.scale ? parseInt(this.editData?.scale) : 2;
      this.area = this.editData?.area
      this.address = this.editData?.address
      this.latitude = this.editData?.address_coordinates?.lat
      this.longitude = this.editData?.address_coordinates?.lng
      this.changeMapType(this.map_type)
      this.imageUrl = this.fileServerUrl + '/' + this.editData?.imgname;
      // this.getGeoLocation(this.address);
      this.floormapService.getMapFile(this.editData?.imgname).pipe(catchError((error: any) => {
     
        return throwError('Something went wrong');
         })
       ).subscribe(blob=>{
         clearTimeout(this.blobtimeout);
         this.imageUrl = undefined;
         this.blobtimeout = setTimeout(()=>{
          let blobs = URL.createObjectURL(blob)
          if(blobs!=this.imageUrl){
           this.imageUrl = URL.createObjectURL(blob);
          }
         
          clearTimeout(this.blobtimeout);
         },500)
 
        //  this.previousSelectedMap = map;
       })
// if(this.map_type=='Composite'){
//   this.initializeImageOverlayWithMarkers();
// }else{
// }
this.overlaySet();
    } else if (this.action == 'Import') {
      this.importData = this.data?.data?.filter(obj =>
        Object.values(obj).some(value => value !== undefined && value !== null && value !== ''
      ));
      this.importDataMethod(this.index)
    } else {
      this.map_type = "PDF"
    }
    this.getRegionData();
    this.getFloorMapData();
    this.maptype = [
      {
        id: 1,
        map_type: "PDF"
      },
      {
        id: 2,
        map_type: "Composite"
      }
    ]

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
    this.campusFilterOptions = this.campusControl.valueChanges.pipe(
      startWith(''),
      map(value => this._campusfilter(value || '')),
    );
    this.buildingFilterOptions = this.buildingControl.valueChanges.pipe(
      startWith(''),
      map(value => this._buildfilter(value || '')),
    );
  }
  ngAfterViewInit(): void {
    // if (this.map_type=='Composite') {
      this.initializeAutocomplete();  // get auto complete dropdown list
      this.action = this.data?.action;
      console.log("action",this.action)
      if (this.action == 'Edit') {
      this.initializeImageOverlayWithMarkers(); // set center dragable marker in edit mode also
      this.center={lat:this.latitude,lng:this.longitude} // set center for center marker 
      }

    // }
  }

 
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.regionsList.filter(option => option.toLowerCase().includes(filterValue));
  }
  private _campusfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.campusOptions.filter(option => option.toLowerCase().includes(filterValue));
  }
  private _buildfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.buildingOptions.filter(option => option.toLowerCase().includes(filterValue));
  }
  importDataMethod(index: number) {
    this.displayName = this.importData[index].mapname;
    this.map_type = this.importData[index].map_type ? this.importData[index].map_type : 'PDF';
    this.region = this.importData[index].region
    this.selectedCampuse = this.importData[index].campus
    this.selectedBuilding = this.importData[index].building
    this.floor = this.importData[index].floor
    this.southWestLat = this.importData[index].south_west_lat ? this.importData[index].south_west_lat : ''
    this.southWestLng = this.importData[index].south_west_lon ? this.importData[index].south_west_lon : ''
    this.northEastLat = this.importData[index].north_east_lat ? this.importData[index].north_east_lat : ''
    this.northEastLng = this.importData[index].north_east_lon ? this.importData[index].north_east_lon : ''
    this.scaleZoom = this.importData[index].scale ? this.importData[index].scale : '-';
    this.zoom = this.map_type == 'Composite' && this.importData[index].scale ? parseInt(this.importData[index].scale) : 2;
    this.area = this.importData[index].area
    this.address = this.importData[index].address;
    this.imageUrl = this.importData[index].file;
    this.imageName = this.importData[index].imageName;
    this.changeMapType(this.map_type)
    this.getGeoLocation(this.address)
    let exists = this.mapsArray.find(item => item.name == this.displayName);
    if (!exists) {
      this.error = '';
    } else {
      this.error = `${this.displayName} Already Exists, Do you want to update it?`;
      this.id = exists.id;
    }
    this.overlaySet();
    this.checkValid();
  }
  overlaySet() {
    this.imageBounds = {
      north: +this.northEastLat,
      east: +this.northEastLng,
      south: +this.southWestLat,
      west: +this.southWestLng,
    };
    this.northEast = { lat: this.northEastLat ? this.northEastLat : '', lng: this.northEastLng ? this.northEastLng : '' }
    this.southWest = { lat: this.southWestLat ? this.southWestLat : '', lng: this.southWestLng ? this.southWestLng : '' }
    // this.scaleZoom = this.scaleZoom ? parseInt(this.scaleZoom) : 2;


  }

  northEastMarkerDrag(e: any) {
    this.northEastLat = e.latLng.lat();
    this.northEastLng = e.latLng.lng();
    this.overlaySet();
  }
  southWestMarkerDrag(e: any) {
    this.southWestLat = e.latLng.lat();
    this.southWestLng = e.latLng.lng();
    this.overlaySet(); 
  }
  centerUpdate(e: any) {
    this.center = { lat: e.latLng.lat(), lng: e.latLng.lng() }
    this.latitude = e.latLng.lat();
    this.longitude = e.latLng.lng();
    this.geocodeService.geocodeFromLatlng(e.latLng).subscribe((res: any) => {
      this.address = res;
    })
  }
  getFloorMapData() {
    var campuses = [];
    var building = [];
    var mapNames = [];
    this.floormapService.getFloorMapDropdownData().subscribe((response: any) => {
      this.rowData = response?.result?.hits;
      this.rowData && this.rowData.map(each => {
        if (each._source.mapname) {
          mapNames.push({ name: each._source.mapname, id: each._id });
        }
        if (each._source.campus) {
          campuses.push(each._source.campus);
        }
        if (each._source.building) {
          building.push(each._source.building);
        }
      })
      this.campusOptions = [...new Set(campuses)];
      this.campusArray = JSON.parse(JSON.stringify(this.campusOptions));
      this.mapsArray = JSON.parse(JSON.stringify(mapNames));

      this.buildingOptions = [...new Set(building)];
      this.buildArray = JSON.parse(JSON.stringify(this.buildingOptions));
      if (this.action == 'Edit') {
        let index = this.mapsArray.findIndex(item => item.name == this.editData?.mapname);

        index !== -1 && this.mapsArray.splice(index, 1)

      }
      let exists = this.mapsArray.find(item => item.name == this.displayName);
      if (!exists) {
        this.error = '';
      } else {
        this.updateButton = this.action == 'Import' ? true : false
        this.error = `${this.displayName} Already Exists, Do you want to update it?`;
        this.id = exists.id;
      }
    })


  }
  closePopup() {
    this.dialogRef.close();
  }
  unquiness() { 
    if (this.action == 'Edit') {
      let index = this.mapsArray.findIndex(item => item.name == this.editData?.mapname); 

      index !== -1 && this.mapsArray.splice(index, 1)

    } 

    let exists = this.mapsArray.find(item => item.name == this.displayName);
    if (!exists) {
      this.error = '';
      return true;
    } else {
      this.updateButton = this.action == 'Import' ? true : false
      this.error = this.action == 'Import' ? `${this.displayName} Already Exists Do you want to update it? ` : `${this.displayName} Already Exists`
      return false;
    }
  }
  checkValid() {
    if (this.displayName && this.action != 'Edit' && this.unquiness()) {
      this.disabled = false;
    } else if (this.displayName && this.action == 'Edit' && this.unquiness()) {
      this.disabled = false;
    } else {
      this.disabled = true;
    }
  }
  get isCompositeInvalid(): boolean {
  if (this.map_type !== 'Composite') return false;

  return !(
    this.southWestLat != null &&
    this.southWestLng != null &&
    this.northEastLat != null &&
    this.northEastLng != null &&
    this.address &&
    this.selectedBuilding
  );
}


  changeDisplayName(event: any) {
    this.importData[this.index] = { ...this.importData[this.index], ...{ mapname: event } }
    this.checkValid();

  }
  changeMapType(event: any) {
    this.selectedMap = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ map_type: event } }
    if(this.map_type=='Composite'){
     
      if (this.map_type=='Composite') {
      this.initializeAutocomplete()}
    }
    
  }
  changeRegion(event) {
    this.selectedRegion = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ region: event } }
    // if (event) {
    //   this.regionsList = this.getMatch(this.regionsArray, event)
    // } else {
    //   this.regionsList = this.regionsArray;
    // }
    this.checkValid();

  }
  getMatch(arr, str) {
    var reg = new RegExp(str.split('').join('.*'), 'i');

    return arr.filter(function (item) {
      if (item.match(reg)) {
        return item;
      }
    });
  }
  changeCampus(event) {
    this.selectedCampuse = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ campus: event } }

    if (event) {
      this.campusOptions = this.getMatch(this.campusArray, event);
    } else {
      this.campusOptions = this.campusArray;
    }
    this.checkValid();

  }
  changeBuilding(event) {
    this.selectedBuilding = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ building: event } }

    if (event) {
      this.buildingOptions = this.getMatch(this.buildArray, event);
    } else {
      this.buildingOptions = this.buildArray;
    }
    this.checkValid();

  }
  changeFloor(event) {
    this.floor = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ floor: event } }

    this.checkValid();

  }
  changeSouthWestLat(event) {
    this.southWestLat = event
    this.importData[this.index] = { ...this.importData[this.index], ...{ south_west_lat: event } }

    // this.importData[this.index][11] = event.target.value;
    this.overlaySet()
    this.checkValid();

  }

  changeSouthWestLng(event) {
    this.southWestLng = event
    this.importData[this.index] = { ...this.importData[this.index], ...{ south_west_lon: event } }


    this.overlaySet()
    this.checkValid();

  }
  changeNorthEastLat(event) {
    this.northEastLat = event
    // this.importData[this.index][13] = event.target.value;
    this.importData[this.index] = { ...this.importData[this.index], ...{ north_east_lat: event } }


    this.overlaySet()
    this.checkValid();

  }
  changeNorthEastLng(event) {
    this.northEastLng = event
    this.importData[this.index] = { ...this.importData[this.index], ...{ north_east_lon: event } }

    // this.importData[this.index][14] = event.target.value;

    this.overlaySet()
    this.checkValid();

  }
  changeScaleZoom(event) {
    this.zoom = this.map_type == 'Composite' && event ? parseInt(event) : 2;
    this.importData[this.index] = { ...this.importData[this.index], ...{ zoom: event } }
    this.overlaySet()
    this.checkValid();

  }
  changeArea(event) {
    this.area = event;
    this.importData[this.index] = { ...this.importData[this.index], ...{ area: event } }
    this.checkValid();
  }
  changeAddress(event) {
    this.address = event
    this.importData[this.index] = { ...this.importData[this.index], ...{ address: event } }
    this.getGeoLocation(this.address)
    this.checkValid();

  }
  getGeoLocation(param) {
    return new Promise((resolve, reject) =>
      this.geocodeService.geocodeAddress(param).subscribe({
        next: response => {
          this.markerPosition = response;
          this.center = response;
          this.latitude = response.lat;
          this.longitude = response.lng;
          resolve(this.center)

        },
        error: err => {
          reject();
        }
      })

    )
  }
  getGeoLocation1(param) {
    return new Promise((resolve, reject) =>
      this.geocodeService.geocodeAddress(param).subscribe({
        next: response => {
          this.markerPosition = response;
          this.center = response;
          this.latitude = response.lat;
          this.longitude = response.lng;
          resolve(this.center)

        },
        error: err => {
          reject();
        }
      })

    )

  }

  getRegionData() {
    this.floormapService.getRegions().subscribe((response: any) => {
      this.regions = response
      this.regionsList = this.regions.map(item => item.name ? item.name : []);
      this.regionsArray = JSON.parse(JSON.stringify(this.regionsList));
    })
  }
  checkValidation(): boolean {
    if (this.data?.from === 'addNewMapFromWalktest') {
      return !this.imageName || !this.imagedata;
    }
    return false;
  }
  async createRecord() {
    this.getFloorMapData();
    this.disabled = true;
    this.formData = {
      mapname: this.displayName,
      imgname: this.imageName,
      region: this.region,
      campus: this.selectedCampuse,
      scale: this.scaleZoom && !isNaN(+this.scaleZoom) ? this.scaleZoom : (this.scaleZoom == undefined || this.scaleZoom.trim().length === 0) ? "-" : this.scaleZoom,
      area: !isNaN(+this.area) ? this.area : (this.area == undefined || this.area.trim().length === 0) ? "-" : this.area,
      building: this.selectedBuilding,
      floor: this.floor,
      address: this.address,
      address_coordinates: this.center,
      region_coordinates: this.region ? await this.getGeoLocation(this.region) : {},
      map_type: this.selectedMap,
      zoom: this.scaleZoom,
      south_west: [this.southWestLat, this.southWestLng],
      north_east: [this.northEastLat, this.northEastLng]
    }
    if (this.data?.action == 'Edit' && this.unquiness()) {
      this.floormapService.updateMapData(this.formData, this.id).subscribe(response => {
        this.toast.success('Record Updated Successfully')
        this.dialogRef.close(this.formData)
        if (this.imagedata && this.imageName) {
          this.isSpinner = true;
          this.floormapService.uploadFile(this.imagedata, this.selectedMap).subscribe(result => {
            this.isSpinner = false;
            this.dialogRef.close(this.formData)
          }, err => {
            this.formData.imgname = '';
        this.toast.error('The floormap upload failed.');

            this.deleteImage(this.formData, this.id);
            this.isSpinner = false;
          })
        } else {
          this.dialogRef.close(this.formData)
        }
      })
    } else if (this.unquiness()) {
      this.floormapService.addMapData(this.formData).subscribe((response: any) => {
        this.toast.success('Record Created Successfully')
        this.dialogRef.close(this.formData)
        if (this.imagedata && this.imageName) {
          this.isSpinner = true;
          this.floormapService.uploadFile(this.imagedata, this.selectedMap).subscribe(result => {
            this.isSpinner = false;
            if (this.action != 'Import') {
              this.dialogRef.close(this.formData)
            }
          }, err => {
            this.formData.imgname = '';
        this.toast.error('The floormap upload failed.');
            this.deleteImage(this.formData, response.result._id);
            this.isSpinner = false;
          })
        } else {
          if (this.action != 'Import') {
            this.dialogRef.close(this.formData)
          }
        }
      })
    }

  }
  deleteImage(formData, id) {
    this.floormapService.updateMapData(formData, id).subscribe(response => {
      this.dialogRef.close()

    })
  }
  async updateRecord() {
    this.formData = {
      mapname: this.displayName,
      imgname: this.imageName,
      region: this.region,
      campus: this.selectedCampuse,
      scale: this.scaleZoom && !isNaN(+this.scaleZoom) ? this.scaleZoom : (this.scaleZoom == undefined || this.scaleZoom.trim().length === 0) ? "-" : this.scaleZoom,
      area: !isNaN(+this.area) ? this.area : (this.area == undefined || this.area.trim().length === 0) ? "-" : this.area,
      building: this.selectedBuilding,
      floor: this.floor,
      address: this.address,
      address_coordinates: this.center,
      region_coordinates: this.region ? await this.getGeoLocation(this.region) : {},
      map_type: this.selectedMap,
      zoom: this.scaleZoom,
      south_west: [this.southWestLat, this.southWestLng],
      north_east: [this.northEastLat, this.northEastLng]
    }
    this.floormapService.updateMapData(this.formData, this.id).subscribe((response: any) => {
      this.toast.success('Record Updated Successfully')
      if (this.imagedata && this.imageName) {
        this.isSpinner = true;
        this.floormapService.uploadFile(this.imagedata, this.selectedMap).subscribe(result => {
          this.isSpinner = false;
          // this.dialogRef.close()
        }, err => {
          this.formData.imgname = '';
        this.toast.error('The floormap upload failed.');
            this.deleteImage(this.formData, response.result._id);
            this.isSpinner = false;
        })
      } else {
        // this.dialogRef.close()
      }
    })
  }

  async saveAll() {
    for (let i = 0; i < this.importData.length; i++) {
      let formData = {
        mapname: this.importData[i].mapname,
        imgname: this.importData[i].imageName,
        region: this.importData[i].region,
        campus: this.importData[i].campus,
        scale: this.importData[i].scale ? this.importData[i].scale : "-",
        area: this.importData[i].area == undefined ? "" : this.importData[i].area,
        building: this.importData[i].building,
        floor: this.importData[i].floor,
        address: this.importData[i].address,
        region_coordinates: this.importData[i].region ? await this.getGeoLocation(this.importData[i].region) : '',

        address_coordinates: this.importData[i].address ? await this.getGeoLocation(this.importData[i].address): {lat: 0, lng: 0},
        map_type: this.importData[i].map_type ? this.importData[i].map_type : 'PDF',
        zoom: this.importData[i].zoom,
        south_west: [this.importData[i].south_west_lat, this.importData[i].south_west_lon],
        north_east: [this.importData[i].north_east_lat, this.importData[i].north_east_lon]
      }
      let obj = this.mapsArray.find(item => item.name == this.importData[i].mapname)
      if (!obj) {
        this.floormapService.addMapData(formData).subscribe((response: any) => {
          this.toast.success('Record Created Successfully')
          if (this.importData[i].file && this.importData[i].imageName) {
            this.isSpinner = true;
            this.floormapService.uploadFile(this.importData[i].file, this.importData[i].map_type).subscribe(res => {
              this.isSpinner = false;
             
            }, err => {
              this.toast.error('The floormap upload failed.');
               formData.imgname = '';

              this.deleteImage(formData, response.result._id);
              this.isSpinner = false;
            })
          }
        })
      } else {
        this.floormapService.updateMapData(formData, obj.id).subscribe((response: any) => {
          this.toast.success('Record Updated Successfully')
          if (this.imagedata && this.imageName) {
            this.isSpinner = true;
            this.floormapService.uploadFile(this.imagedata, this.importData[i].map_type).subscribe(result => {
              
            }, err => {
              formData.imgname = '';
              this.toast.error('The floormap upload failed.');
              this.deleteImage(formData, response.result._id);
              this.isSpinner = false;
            })
          } else {

          }
        })
      }
      if (i == this.importData.length - 1) {
        this.dialogRef.close();
      }
    }
  }

  previous() {
    this.index = this.index - 1;
    this.importDataMethod(this.index)

  }
  next() {
    this.imageUrl = '';
    this.index = this.index + 1
    this.importDataMethod(this.index)
  }
  navigate(direction: 'next' | 'previous') {
  if (!this.importData?.length) return;

  const lastIndex = this.importData.length - 1;

  if (direction === 'next' && this.index < lastIndex) {
    this.index++;
  }

  if (direction === 'previous' && this.index > 0) {
    this.index--;
  }

  this.importDataMethod(this.index);
}
get isFirst(): boolean {
  return this.index === 0;
}

get isLast(): boolean {
  return this.index === this.importData.length - 1;
}





  handleFileUpload(e: any) {
    this.imageError = false;
    this.error = '';
    if(this.map_type == 'PDF'){this.tabIndex = this.map_type == 'PDF' ? 2 : 1;}
    if (e.target.files[0]) {
      var reader = new FileReader();
      let file = e.target.files[0];
      reader.readAsDataURL(file); // read file as data url
      this.disabled = false;
      reader.onload = (event) => { // called once readAsDataURL is completed
        this.imageUrl = event.target.result;
      }
      if (this.action == 'Import') {
        this.importData[this.index] = { ...this.importData[this.index], ...{ file: file } }
      }
      this.imagedata = file;
      var fileExtension = '.' + file.name.split('.').pop();
      let name = (Math.random().toString(36).substring(7) + new Date().getTime() + fileExtension).toString();
      this.imagedata.updatedName = name
      if (this.action == 'Import') {
        this.importData[this.index] = { ...this.importData[this.index], ...{ imageName: name } }
      }
      this.imageName = this.imagedata.updatedName;
      if(this.map_type=='Composite'){
        this.overlaySet();
      }
    }
  }

  initializeAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.searchInput?.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();
        this.address=place?.formatted_address;
        if (place.geometry?.location) {
          this.markerPosition = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          this.center = this.markerPosition; // Recenter map
          this.zoom = 18;
          this.latitude=this.markerPosition?.lat;
          this.longitude=this.markerPosition?.lng
          this.initializeImageOverlayWithMarkers(); //set all corners to create center marker
        }
      });
    });
  }

  initializeImageOverlayWithMarkers() {
            // Define zoom-based offsets for image size
            const zoomFactor = 0.01 / this.zoom; // Adjust scaling factor as needed
 this.modifyBound();
//  console.log("markers",this.latitude,this.longitude)
 this.center={lat:this.latitude,lng:this.longitude} 
//  console.log("markers",this.center)
        //     // Add a draggable marker for the center
        //     // Define the corners for draggable markers
            const sw = { lat: this.center.lat - zoomFactor, lng: this.center.lng - zoomFactor }; // South-West
    const ne = { lat: this.center.lat + zoomFactor, lng: this.center.lng + zoomFactor }; // North-East
    const nw = { lat: ne.lat, lng: sw.lng }; // North-West
    const se = { lat: sw.lat, lng: ne.lng }; // South-East
    const corners = [sw, nw, ne, se];
        this.createCenterDragMarker(corners);
     }
     modifyBound(){ // set marker coordinates and bounds every time change
      const zoomFactor = 0.01 / this.zoom; // Adjust scaling factor as needed
      this.imageBounds = {
        north: +this.northEastLat ? this.northEastLat : this.latitude-zoomFactor,
        east: +this.northEastLng ? this.northEastLng : this.longitude-zoomFactor,
        south: +this.southWestLat ? this.southWestLat : this.latitude-zoomFactor,
        west: +this.southWestLng ? this.southWestLng : this.longitude-zoomFactor,
      };
      this.northEastLat=this.northEastLat ? this.northEastLat : this.latitude+zoomFactor;
      this.northEastLng=this.northEastLng ? this.northEastLng : this.longitude+zoomFactor;
  
      this.southWestLat=this.southWestLat ? this.southWestLat : this.latitude-zoomFactor;
      this.southWestLng=this.southWestLng ? this.southWestLng : this.longitude-zoomFactor;
  
      this.northEast = { lat: this.northEastLat ? this.northEastLat : '', lng: this.northEastLng ? this.northEastLng : '' }
      this.southWest = { lat: this.southWestLat ? this.southWestLat : '', lng: this.southWestLng ? this.southWestLng : '' }
 
     }
     createCenterDragMarker(corners: google.maps.LatLngLiteral[]) {
      console.log("corners",corners)
      // Calculate the initial center of the image overlay
      let centerLat = (corners[0].lat + corners[2].lat) / 2; // Midpoint of SW and NE
      let centerLng = (corners[0].lng + corners[2].lng) / 2;
    
      const mapInstance = this.map?.googleMap;
      if (!mapInstance) {
        console.error('Map instance is not initialized');
        return;
      }
      // Create a draggable marker at the center
      const centerMarker = new google.maps.Marker({
        position: { lat: centerLat, lng: centerLng },
        map: mapInstance,
        draggable: true,
        label: 'C',
      });
    
      // Listen for drag events on the center marker
      centerMarker.addListener('drag', () => {
        const newCenter = centerMarker.getPosition()!.toJSON(); // Get the new position of the center marker
        const dLat = newCenter.lat - centerLat; // Change in latitude
        const dLng = newCenter.lng - centerLng; // Change in longitude
    
        // Update all corner positions relative to the new center
        corners.forEach((corner) => {
          corner.lat += dLat;
          corner.lng += dLng;
        });
    
        // Update the overlay bounds dynamically
        this.imageBounds = {
          north: corners[2].lat, // NE
          east: corners[2].lng,
          south: corners[0].lat, // SW
          west: corners[0].lng,
        };
         // Update the current center coordinates
         this.latitude = newCenter.lat;
         this.longitude = newCenter.lng;
        const zoomFactor = 0.01 / this.zoom; // Adjust scaling factor as needed
        this.imageBounds = {
          north: +this.northEastLat ? this.northEastLat : this.latitude-zoomFactor,
          east: +this.northEastLng ? this.northEastLng : this.longitude-zoomFactor,
          south: +this.southWestLat ? this.southWestLat : this.latitude-zoomFactor,
          west: +this.southWestLng ? this.southWestLng : this.longitude-zoomFactor,
        };
        this.northEastLat= this.latitude+zoomFactor;
        this.northEastLng= this.longitude+zoomFactor;
    
        this.southWestLat=this.latitude-zoomFactor;
        this.southWestLng=this.longitude-zoomFactor;

        this.northEast = { lat: this.northEastLat ? this.northEastLat : '', lng: this.northEastLng ? this.northEastLng : '' }
    this.southWest = { lat: this.southWestLat ? this.southWestLat : '', lng: this.southWestLng ? this.southWestLng : '' }
   
      });
    
      // Add the center marker to the markers array
      this.markers.push(centerMarker);
    }
      
}
